<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div style="margin-top: -7rem !important;">
    <div class="page-header-card mb-3" :class="{ 'nav-orange-gradient-bg' : $getSiteId() == 33, 'nav-green-gradient-bg' : $getSiteId() == 35, 'nav-redish-gradient-bg' : $getSiteId() != 35 }">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-row mb-4 mt-5">
            <div class="vx-col w-full text-center">
              <custom-svg v-if="$getSiteId() == 33 || $getSiteId() == 35" variant="pie-chart-2" width="70" height="70" color="white" />
              <custom-svg v-else variant="pie-chart" width="60" height="60" color="white" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full text-center">
              <h2 style="color: white">status</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showLoading">
      <custom-skeleton size="large" :count="7" />
    </div>

    <div v-else>
      <div v-for="_course in courses" :key="_course.id">
        <vs-divider><h5>{{ _course.name }}</h5></vs-divider>
        <div v-for="(_item, index) in coursesAndModules.filter(x => x.courseId == _course.id)" :key="index">
          <div style="border-radius: 30px; background-color: rgba(0,0,0,0.5);" class="mb-3 light-gray-border border-3px" >
            <div class="vx-row" style="padding: 1.5rem">
              <div class="vx-col w-full" style="padding-left: 1rem; padding-right: 1rem;">
                <div class="vx-row cursor-pointer" @click.stop="handleSelectedCourse(_item)">
                  <div class="vx-col w-1/6 center-v-h" style="padding-left: 0; padding-right: 0;">
                    <feather-icon icon="GridIcon" class="text-white" svg-classes="stroke-current h-12 w-12"></feather-icon>
                  </div>
                  <div class="vx-col w-2/3 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                    <div class="vx-row">
                      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                        <p class="mb-1 font-white" style="font-size: 1.8rem;font-weight: 600;letter-spacing: -2px;line-height: 1.2;">{{_item.moduleName}}</p>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col w-full" style="padding-left: 0;">
                        <div v-if="_item.studentModuleStatusId == 9 || _item.studentModuleStatusId == 2">
                          <div v-if="_item.lastTaskCompleted"> 
                            <h5 style="color: rgba(var(--vs-success),1)">Completed</h5>
                          </div>
                          <div v-else-if="_item.moduleProgress != 100" class="text-center mt-1">
                            <vs-progress
                              :percent="Number(_item.moduleProgress)"
                              :color="getProgressColor(Number(_item.moduleProgress))"
                              :height="12"
                              class="shadow-md"
                            />
                            <span>{{_item.moduleProgress.toFixed(2) + '%'}}</span>
                          </div>
                          <div v-else>
                            <h5 style="color: rgba(var(--vs-danger),1)">Not yet started</h5>
                          </div>
                        </div>
                        <div v-else-if="_item.lastTaskCompleted && _item.studentModuleStatusId == 1">
                          <h5 style="color: rgba(var(--vs-success),1)">Completed</h5>
                        </div>
                        <div v-else-if="_item.studentModuleStatusId != 9 && _item.studentModuleStatusId != null">
                          <h5 style="color: rgba(var(--vs-success),1)">{{ _item.studentModuleStatus }}</h5>
                        </div>
                        <div v-else>
                          <h5 style="color: #ebeefd">No Status</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="vx-col w-1/6 center-v-h" style="padding-right: 0;">
                    <custom-svg class="menu--icon arrow--icon" variant="arrow" color="white" :dir="showTasks && selectedModuleId == _item.moduleId ? 'down' : 'right'" />
                  </div>
                </div>
                <div class="vx-row" v-if="showTasks && selectedModuleId == _item.moduleId">
                  <div class="vx-col w-full">
                    <vs-divider><h6>Tasks</h6></vs-divider>
                    <div v-if="showLoadingTasks">
                      <custom-skeleton size="large" :count="4" />
                    </div>
                    <div v-else>
                      <div v-for="_task in tasks" :key="_task.taskId" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                        <div style="border-radius: 20px; background-color: rgba(255,255,255,0.1);" class="mb-3 light-gray-border border-3px" :class="{ 'cursor-pointer': _task.statusId == 12 }" @click.stop="showActionableAssessments(_task)">
                          <div class="vx-row mt-3">
                            <div class="vx-col w-full">
                              <div class="vx-row">
                                <div class="vx-col w-1/2">
                                  <h5 class="text-left ml-3">{{ _task.type }}</h5>
                                </div>
                                <div v-if="_task.dateCompleted.replace('T', ' ').split('.')[0] != '0001-01-01 00:00:00'" class="vx-col w-1/2" style="align-self: self-end;">
                                  <h6>{{ _task.dateCompleted.replace("T", " ").split('.')[0] }}</h6>
                                </div>
                              </div>
                              <vs-divider/>
                            </div>
                          </div>
                          <div class="vx-row pb-2">
                            <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                              <h4>{{ _task.count }}</h4>
                            </div>
                            <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                              <div class="vx-row" style="white-space: normal;">
                                <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                                  <p class="mb-1 font-white task-name-heading" style="font-weight: 600;letter-spacing: -2px;line-height: 1.2;">{{_task.task}}</p>
                                </div>
                              </div>
                              <div class="vx-row">
                                <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                                  <h5 v-if="_task.statusId && _task.statusId != 1" :style="{ color: `rgba(var(--vs-${getStatusColor(_task.statusId)}),1)` }">{{ _task.status}}</h5>
                                  <h5 v-else-if="_task.statusId == 1" :style="{ color: `rgba(var(--vs-${getStatusColor(_task.statusId)}),1)` }">{{ 'Waiting to be Assessed' }}</h5>
                                  <h5 v-else>{{ _task.status}}</h5>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                              <custom-svg v-if="_task.statusId == 11 || _task.statusId == 12" class="status_task--icon arrow--icon" style="margin-top: -12px;" variant="arrow" color="white" dir="right" />
                              <custom-svg v-else class="status_task--icon check--icon" style="margin-top: -12px;" variant="check-circle" color="white" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
export default {
  components: {
    CustomSvg
  },
  data() {
    return {
      quizViewIsActive: false,
      quiz: {},
      itemsPerPage: 6,
      isMounted: false,
      loadingColor: "#fff",
      coursesAndModules: [],
      tasks: [],
      statussesToShow: [1, 2, 3, 4, 5, 6, 11,12],
      showTasks: false,
      showOnlyAssessed: false,
      selectedModuleId: 0,
      popupXBtnClicked: false,
      popupXBtnClickedISpring: false,
      iSpringQuizViewIsActive: false,
      ispringQuiz: {},
      taskTypeId: 0,
      statusHistoryIsActive: false,
      selectedStatusHistory: {},
      selectedStatusHistoryData: {},
      captureTimeForAssessments: false,
      timeCapture: {
        captureTimeForAssessments: false,
        formativeHoursRequired: null,
        summativeHoursRequired: null,
        sliderMinFormatives: 0,
        sliderMaxFormatives: 0,
        sliderMinSummatives: 0,
        sliderMaxSummatives: 0,
        taskClassificationTypeId: 0,
      },
      courses: [],
      showLoading: false,
      currentStudentId: null,
      showLoadingTasks: false
    };
  },
  watch: {
    showOnlyAssessed: function() {
      this.$refs.tasksTable.currentx = 1;
      this.loadTasks();
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.courseTable.currentx;
      }
      return 0;
    }
  },
  methods: {
    showStatusHistory(moduleId){
      var self = this;

      // self.showLoadingOnElement("whole_page", 1, "corners");

      var onSuccess = function(response) {
        self.selectedStatusHistory = response.data;

        self.statusHistoryIsActive = true;
        
      };
      var onFinally = function() {
        // self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(self, `Student/StatusHistoryForStudentModule?moduleId=${moduleId}`, onSuccess, onFinally);
    },
    postEndLog(payload) {
      var self = this;
      
      self.$ajaxPost(self, "QuizTask/EndLogEntryByClosingPopup", payload);
    },
    postEndLogISpring(payload) {
      var self = this;
      var onSuccess = function (response) {

      };
      self.$ajaxPost(self, "ISpringQuizTask/EndLogEntry", payload, onSuccess);
    },
    handlePopupClose() {
      this.initTimeCaptureValues();
      this.popupXBtnClicked = true;
      this.$store.dispatch("updateTheme", "dark");
    },
    handlePopupCloseISpring() {
      this.initTimeCaptureValues();
      this.popupXBtnClickedISpring = true;
    },
    closePopup() {
      this.initTimeCaptureValues();
      this.quizViewIsActive = false;
      this.iSpringQuizViewIsActive = false;
    },
    initTimeCaptureValues(){
      this.timeCapture.captureTimeForAssessments = false;
      this.timeCapture.formativeHoursRequired = null;
      this.timeCapture.sliderMaxFormatives = 0;
      this.timeCapture.sliderMaxSummatives = 0;
      this.timeCapture.sliderMinFormatives = 0;
      this.timeCapture.sliderMinSummatives = 0;
      this.timeCapture.summativeHoursRequired = null;
      this.timeCapture.taskClassificationTypeId = 0;
    },
    loadCourseInfo() {
      const self = this;
      self.showLoading = true;

      var onSuccess = function(response) {
        self.courses = [];
        var temp = response.data;

        if (temp) {
          var temp_courses = [];
          temp_courses = temp.map(function(_item) {
            return {
              id: _item.courseId,
              name: _item.courseName,
              // captureTimeForAssessments: _item.captureTimeForAssessments,
              moduleId: _item.moduleId
            };
          });
          temp_courses.forEach(_course => {
            if (
              self.courses.filter(function(item) {
                return _course.id == item.id;
              }).length == 0
            )
              self.courses.push(_course);
          });
          self.courses = self.courses.sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
          });

          self.coursesAndModules = temp;
        }
      };
      var onFinally = function() {
        self.showLoading = false;
      };

      self.$ajaxGet(self, "Student/ListCourseInfo", onSuccess, onFinally);
    },
    handleSelectedCourse(courseModule) {
      var self = this;
      
      if (!self.selectedModuleId || self.selectedModuleId != courseModule.moduleId) {
        self.tasks = [];
        self.showTasks = true;
        self.selectedModuleId = courseModule.moduleId;
        // self.captureTimeForAssessments = courseModule.captureTimeForAssessments;
        self.getTaskProgress();
      } else {
        self.selectedModuleId = null;
        self.captureTimeForAssessments = null;
        self.tasks = [];
      }
    },
    getTaskProgress(){
      var self = this;
      self.showLoadingTasks = true;
      var onSuccess = function(response){
        self.tasks = response.data;
      }

      var onFinally = function () {
        self.showLoadingTasks = false;
      };

      self.$ajaxGet(self, "Assessor/AssessmentProgress?studentId=" + self.currentStudentId + "&moduleId=" + self.selectedModuleId, onSuccess, onFinally);
    },
    loadTasks() {
      var self = this;
      // self.showLoadingOnElement("whole_page", 1, "corners");

      var onSuccess = function (response) {
        self.tasks = response.data;
      };
      var onFinally = function () {
        // self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(
        self,
        "Student/ListStudentTasks?moduleId=" + self.selectedModuleId + "&showOnlyAssessed=" + self.showOnlyAssessed,
        onSuccess,
        onFinally
      );
    },
    showActionableAssessments(_task) {
      if (_task.statusId == 11 || _task.statusId == 12) {
        this.$router.push({ name: "Gen2ReviewTasks", query: { taskId: _task.taskId, moduleId: this.selectedModuleId } });
      }
    },
    handleSelectedTask(task) {
      if(task.statusId == 2 || task.statusId == 3 || task.statusId == 7 || task.statusId == 11 || task.statusId == 12 || task.statusId == 14){
        let routeData = this.$router.resolve({ name: 'ViewAssessment', query: { TaskLogId: task.logId } });
        window.open(routeData.href, '_blank');
      }
      else{
        this.openAlert(task.statusId);
        return;
      }
    },
    getProgressColor(num) {
      if (num > 99) return "success";
      if (num <= 99) return "warning";
    },
    getStatusColor(statusId) {
      if(statusId == 6)
        return 'primary';
      else if(statusId == 3|| statusId == 2 || statusId == 15)
        return 'success';
      else if(statusId == 5 || statusId == 10)
        return 'danger';
      else if(statusId == 0)
        return 'light'
      else if(statusId == 1){
        return 'danger'
      }
      else
        return 'warning'; 
    },
    setStatusName(statusName) {
      if(statusName == 'Completed')
        return 'Waiting for Assessment';
      else if(statusName == 'Query')
        return 'Queried';
      else if(statusName == 'Moderated')
        return 'Moderated';
      else if(statusName == 'ReadyForStudentReview' || statusName == 'SurveyReadyForStudentReview'){
        return 'Waiting for Student'
      }
      else
        return statusName;
    },
    openAlert(status){
      if(status == 1) {
        this.$vs.dialog({
          color: 'warning',
          title: 'Information',
          text: 'Sorry, this task has not been assessed yet.',
          acceptText: 'Okay'
        })
      }
      else if(status == 5) {
        this.$vs.dialog({
          color: 'danger',
          title: 'Information',
          text: 'You have already queried this assessment.',
          acceptText: 'Okay'
        })
      }
      else if(status == 6) {
        this.$vs.dialog({
          color: 'success',
          title: 'Information',
          text: 'You have already accepted the assessment of this task.',
          acceptText: 'Okay'
        })
      }
    },
    getQuizTask(taskId, taskTypeId) {
      var self = this;
      self.taskTypeId = taskTypeId;
      
      if (taskTypeId == 9) {
        self.popupXBtnClicked = false;
        self.quiz = {};
        // self.showLoadingOnElement("whole_page", 1, "corners");

        if(self.captureTimeForAssessments && self.$siteTypeId() != 1)
            self.getTimeCaptureInfo(taskId);

        var onSuccess = function (response) {
          self.quiz = response.data;
          self.quizViewIsActive = true;
        };
        var onFinally = function () {
          // self.$vs.loading.close(self.$refs.whole_page.$el);
        };

        self.$ajaxGet(
          self,
          "Student/GetQuizTask?moduleId=" + self.selectedModuleId + "&quizTaskId=" + taskId,
          onSuccess,
          onFinally
        );
      } else if (taskTypeId == 14) {
        self.popupXBtnClicked = false;
        self.quiz = {};

        if(self.captureTimeForAssessments && self.$siteTypeId() != 1)
            self.getTimeCaptureInfo(taskId);

        // self.showLoadingOnElement("whole_page", 1, "corners");

        var onSuccess = function (response) {
          self.quiz = response.data;
          self.quizViewIsActive = true;
        };
        var onFinally = function () {
          // self.$vs.loading.close(self.$refs.whole_page.$el);
        };

        self.$ajaxGet(
          self,
          "Student/GetVideoQuizTask?moduleId=" + self.selectedModuleId + "&taskId=" + taskId,
          onSuccess,
          onFinally
        );
      } else {
        self.popupXBtnClickedISpring = false;
        self.ispringQuiz = {};
        // self.showLoadingOnElement("whole_page", 1, "corners");

        var onSuccess = function (response) {
          self.ispringQuiz = response.data;
          self.iSpringQuizViewIsActive = true;
        };
        var onFinally = function () {
          // self.$vs.loading.close(self.$refs.whole_page.$el);
        };

        self.$ajaxGet(
          self,
          "Student/GetiSpringQuizTask?moduleId=" + self.selectedModuleId + "&taskId=" + taskId,
          onSuccess,
          onFinally
        );
      }
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    getTimeCaptureInfo(taskId){
      var self = this;

      var onSuccess = function (response) {
        self.getTimeCaptureDetail(response.data, taskId)
      };

      self.$ajaxGet(self, "course/getstory/" + self.selectedModuleId, onSuccess);
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    },
    scrollToFooter() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -480,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("footerGlobal"),
        100,
        scrollOptions
      );
    },
    getTimeCaptureDetail(story, taskId){
      var self = this;

      self.timeCapture.captureTimeForAssessments = story.captureTimeForAssessments;
      self.timeCapture.formativeHoursRequired = story.formativeHoursRequired;
      self.timeCapture.summativeHoursRequired = story.summativeHoursRequired;
      self.timeCapture.taskClassificationTypeId = story.tasks.filter(x => x.Id == taskId).taskClassificationTypeId;

      if(!self.timeCapture.taskClassificationTypeId){
        self.getTaskClassificationId(story, taskId);
      }else{
        self.getMinMaxForTimeCapture(story);
      }
    },
    getTaskClassificationId(story, taskId){
      var self = this;

      var onSuccess = function (response) {
        self.timeCapture.taskClassificationTypeId = response.data;
        self.getMinMaxForTimeCapture(story)
      };

      self.$ajaxGet(self, "student/getTaskClassificationId?taskId=" + taskId, onSuccess);
    },
    getMinMaxForTimeCapture(story){
      var self = this;

      var formativesCount = story.tasks.filter(x => x.taskClassificationTypeId == 1).length;
      var summativesCount = story.tasks.filter(x => x.taskClassificationTypeId == 2).length;

      self.timeCapture.sliderMinFormatives = Math.ceil(self.timeCapture.formativeHoursRequired/formativesCount);
      self.timeCapture.sliderMinSummatives = Math.ceil(self.timeCapture.summativeHoursRequired/summativesCount);

      self.timeCapture.sliderMaxFormatives = Math.ceil(self.timeCapture.sliderMinFormatives + (self.timeCapture.sliderMinFormatives * 50/100));
      self.timeCapture.sliderMaxSummatives = Math.ceil(self.timeCapture.sliderMinSummatives + (self.timeCapture.sliderMinSummatives * 50/100));
    },
  },
  mounted() {
    var self = this;
    self.currentStudentId = localStorage.getItem('Current_User_Id');
    self.loadCourseInfo();
    if(self.$route.params.CourseProgress){
      this.$refs.courseTable.searchx = self.$route.params.CourseProgress ;
    }
    self.isMounted = true;
  }
}
</script>
<style lang="scss">

.vs-progress--background {
  z-index: 1 !important;
}

#top-right-close {
  right: 0;
  position: absolute;
  top: 0;
  margin-right: 3px;
  margin-top: 3px;
}

#milestones-row {
  align-items: flex-end;
}

#delete-column {
  text-align: -webkit-center;
  text-align: -moz-center;
}

.numberinput {
  background: #ffffff;
  float: left;
}

#optionText_TextArea {
  width: 50%;
}

#statusHistory div.vs-popup {
  width: 1000px;

  .vs-popup--content {
    max-height: none;
  }
}

#historyButton{
  border-radius: 40px 40px 40px 40px
}

#statushistorycolumn{
  width: 80px !important;
}

#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }

          &.img-container {
            span {
              display: flex;
              justify-content: center;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.hoursUsed {
  display:flex ;
  justify-content: center ;
  justify-items: center;
  flex-direction: column;
  text-align: center;
  align-items: center;
  width: 70%;
  margin: 0 auto;
}

@media screen and (max-width: 900px) {  
  .hoursUsed{
    width: 90%;
  }
}

@media screen and (max-width: 550px) {
  .vue-slider-mark-label{
    font-size: 8px;
  }
}

</style>